module.exports = __WEBPACK_EXTERNAL_MODULE_163__;


//////////////////
// WEBPACK FOOTER
// external "tether"
// module id = 163
// module chunks = 0